import "./Statistic.scss";
import { Button } from "../../../../../../../components/ui/Buttons/Button/Button";
import { IconSvg } from "../../../../../../../utils/constants/icons/iconSvg.constant";
import { useTranslation } from "../../../../../../../hooks";
import { DetailingList } from "./components/DetailingList/DetailingList";
// import { Chart } from "./components/Chart/Chars";

export const Statistic = () => {
  const { cabinet: { orders: { residential: {
    key, activity, active, paused,
    no, deactivationDate, trafficLimit,
    trafficUsed, detailing, exportLabel
  } } } } = useTranslation();

  return (
    <div className="statistic">
      <div className="statistic__chart-container">
        <div className="statistic__info">
          <div className="statistic__key statistic__title">{key}: 06kfjf02839jjd049488</div>
          <ul className="statistic__info-items">
            <li className="statistic__info-item">
              <div className="statistic__label">{activity}:</div>
              <div className="statistic__value">{active}</div>
            </li>
            <li className="statistic__info-item">
              <div className="statistic__label">{paused}:</div>
              <div className="statistic__value">{no}</div>
            </li>
            <li className="statistic__info-item">
              <div className="statistic__label">{deactivationDate}:</div>
              <div className="statistic__value">02/03/2025 22:45</div>
            </li>
            <li className="statistic__info-item">
              <div className="statistic__label">{trafficLimit}:</div>
              <div className="statistic__value">28 GB</div>
            </li>
            <li className="statistic__info-item">
              <div className="statistic__label">{trafficUsed}:</div>
              <div className="statistic__value">20.6 GB</div>
            </li>
          </ul>
        </div>
        {/*<Chart />*/}
      </div>
      <div className="statistic__detailing-list__wrapper">
        <div className="statistic__table-container">
          <div className="statistic__head">
            <div className="statistic__title">{detailing}</div>
            <div className="statistic__export-button">
              <Button tab="gray-gradient">
                <div className="statistic__export-icon"><IconSvg tag="download"/></div>
                <div className="statistic__export-text">{exportLabel}</div>
              </Button>
            </div>
          </div>
          <DetailingList />
        </div>
      </div>
    </div>
  );
};
